"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBlock = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
const dom_1 = require("../../utils/dom");
const CONTAINER_SELECTOR = `[data-product-block-container]`;
class ProductBlock extends base_component_1.BaseComponent {
    updateByVariantId(variantId) {
        const node = (0, utils_1.$el)(CONTAINER_SELECTOR, this);
        const newNode = (0, dom_1.getTemplateContent)((0, utils_1.$el)(`[data-product-block-template="${variantId}"]`, this));
        (0, dom_1.replaceNodeChildren)(node, newNode);
    }
}
exports.ProductBlock = ProductBlock;
